export default __webpack_public_path__ + "static/media/net-grey.ca329a28.svg";